import React from "react";

const ScrollDown = () => {
  return (
    <div className="scroll__down">
      <span className="home__scroll-name"> Scroll Down</span>
      <span className="mouse">
        <span className="wheel"></span>
      </span>
    </div>
  );
};

export default ScrollDown;
